export default __webpack_public_path__ + "static/media/squareup-logo.53cb67ec.png";